import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=2cb04347&scoped=true&"
import script from "./BaseInputDate.vue?vue&type=script&lang=js&"
export * from "./BaseInputDate.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDate.vue?vue&type=style&index=0&id=2cb04347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb04347",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb04347')) {
      api.createRecord('2cb04347', component.options)
    } else {
      api.reload('2cb04347', component.options)
    }
    module.hot.accept("./BaseInputDate.vue?vue&type=template&id=2cb04347&scoped=true&", function () {
      api.rerender('2cb04347', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputDate.vue"
export default component.exports